export default __webpack_public_path__ + "static/media/produtos_qualidade.6712ae67.png";